"use client";
import "@/styles/aboutOneContent.style.css";
import useLocalizer from "@/hooks/useLocalizer";
import { cn } from "@/lib/utils/utils";
import Text from "@/components/shared/text";
import Flex from "@/components/core/flex";
import { Feature } from "@/types/home";
import { useMemo } from "react";
import DynamicIcon from "@/components/shared/dynamicIcon";

interface Props {
  data?: Feature[];
}
const FeatureContent = ({ data }: Props) => {
  const { isRtl } = useLocalizer();
  const features = useMemo(() => {
    return data?.map((feature) => {
      return {
        icon: (
          <DynamicIcon
            name={feature?.icon?.code ?? ""}
            size={40}
            className={cn(
              "text-primary feature-icon z-10",
              feature?.icon?.classes ?? "",
            )}
          />
        ),
        title: isRtl ? feature?.arTitle : feature?.enTitle,
        description: isRtl ? feature?.arDescription : feature?.enDescription,
        href: feature?.href,
      };
    });
  }, [data, isRtl]);
  return (
    <section className="relative z-10 lg:-bottom-30 -bottom-10">
      <div className="container mx-auto px-6 lg:px-0">
        <FeatureContainer items={features ?? []} />
      </div>
    </section>
  );
};

interface FeatureContainerProps {
  items: {
    icon: React.JSX.Element;
    title: string;
    description?: string | null;
    href?: string | null;
  }[];
}

const FeatureContainer: React.FC<FeatureContainerProps> = ({ items }) => {
  const { isRtl } = useLocalizer();
  return (
    <ul className="grid gap-y-4 lg:grid-cols-2 lg:gap-y-4 xl:grid-cols-4  items-center [&_li]:last-of-type:border-0 lg:px-30">
      {items.map((item, index) => {
        return (
          <li
            key={index}
            className={cn(
              "relative w-full h-96 p-8 bg-muted overflow-hidden transition-all duration-300 ease-in-out  hover:text-white hover:[&_h5]:text-white hover:[&_p]:text-muted/80 hover:[&_.feature-icon]:text-white hover:[&_.feature-icon-link]:text-white hover:[&_.feature-icon-link]:bg-secondary hover:[&_.feature-cover]:h-full ",
              isRtl
                ? "border-l border-primary/20"
                : "border-r border-primary/20",
            )}
          >
            <div className="absolute bottom-0 bg-primary w-full h-0 left-0 right-0 feature-cover transition-all duration-300 ease-in-out" />
            <div className="realtive flex flex-col  w-full h-full justify-between">
              <Flex direction="col" justify="start" spacing={{ all: 4 }}>
                {item.icon}
                <Text as="h3" className="text-secondary font-bold z-20">
                  {item.title}
                </Text>
                {item?.description && (
                  <Text className="text-secondary-foreground lg:text-xl text-lg line-clamp-4 z-10">
                    {item.description}
                  </Text>
                )}
              </Flex>
              {/* {item?.href && (
                <Link
                  className="h-10 w-10 z-20"
                  href={item.href!}
                  aria-label={item.title}
                >
                  <Flex
                    center
                    className="transition-all duration-300 ease-in-out bg-white shadow text-primary w-full h-full feature-icon-link"
                  >
                    {isRtl ? <BsArrowUpLeft /> : <BsArrowUpRight />}
                  </Flex>
                </Link>
              )} */}
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default FeatureContent;
